import React, { Component } from 'react';
import axios from 'axios';
// import SubmitAnswer from './SubmitAnswer';
import auth0Client from '../Auth';

class Question extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: null
    };

    this.submitAnswer = this.submitAnswer.bind(this);
  }

  async componentDidMount() {
    await this.refreshQuestion();
  }

  async refreshQuestion() {
    const {
      match: { params }
    } = this.props;

    const question = (await axios.get(
      `https://4z8a9fq0e7.execute-api.us-east-1.amazonaws.com/dev/questions/${
        params.questionId
      }`,
      {
        headers: { Authorization: `Bearer ${auth0Client.getIdToken()}` }
      }
    )).data;
    this.setState({
      question
    });
  }

  async submitAnswer(answer) {
    await axios.post(
      `https://4z8a9fq0e7.execute-api.us-east-1.amazonaws.com/dev/questions/answer/${
        this.state.question.id
      }`,
      {
        answer
      },
      {
        headers: { Authorization: `Bearer ${auth0Client.getIdToken()}` }
      }
    );
    await this.refreshQuestion();
  }

  render() {
    const { question } = this.state;
    if (question === null)
      return (
        <div className="d-flex justify-content-center">
          <div className="loader" />
        </div>
      );
    return (
      <div className="container">
        <div className="row">
          <div className="jumbotron col-12">
            <h1 className="display-3">{question.title}</h1>
            <p className="lead">{question.description}</p>
            {/* <hr className="my-4" />
            <SubmitAnswer
              questionId={question.id}
              submitAnswer={this.submitAnswer}
            />
            <p>Answers:</p>
            {question.answers.map((answer, idx) => (
              <p className="lead" key={idx}>
                {answer.answer}
              </p>
            ))} */}
          </div>
        </div>
      </div>
    );
  }
}

export default Question;
